import { supabase as defaultSupabase } from "../../supabase";
import { shouldSkipSupabase } from "../../helpers/guestMode";
import { isOffline } from "../../helpers/connectivity";

/**
 * @typedef {Object} ExecutiveBriefingInput
 * @property {object|null} actor
 * @property {string|null} [displayName]
 * @property {object} [orgSettings]
 * @property {string[]} [directReportIds]
 * @property {object|null} [orgPolicies]
 * @property {(capability: string, context?: object) => boolean} can
 * @property {import("@supabase/supabase-js").SupabaseClient} [supabaseClient]
 * @property {Date} [date]
 */

/**
 * @param {ExecutiveBriefingInput} input
 */
export function createExecutiveBriefingContext(input) {
  const {
    actor,
    displayName = null,
    orgSettings = {},
    directReportIds = [],
    orgPolicies = null,
    can,
    supabaseClient = defaultSupabase,
    date = new Date(),
  } = input;

  return {
    actor,
    displayName,
    orgSettings,
    directReportIds,
    orgPolicies,
    can,
    supabaseClient,
    date,
    isGuest: shouldSkipSupabase(actor),
    isOffline: isOffline(),
    scopeContext: { directReportIds, orgSettings },
    data: {},
  };
}
